import React, { Component } from "react";
import axios from "axios";
import store from "store";
import Cover2 from "../../../Assets/img/default-cover-image.svg";
import "../../../Assets/css/Login.css";
import "./index.css";

class PublicFeePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admissionNo: "",
      collectfee: [],
      studentData: null,
      student_class: null,
      student_section: null,
      isSearching: false,
      searchCompleted: false,
      selectcollectfee: [],
      total_amount: 0,
      partial_payment_amount: 0,
      isPartialPayment: false,
      receipt_no: "Online_" + Math.floor(Math.random() * 100000),
      payment_date: `${new Date().getFullYear()}-${
        (new Date().getMonth() + 1 < 10 ? "0" : "") +
        (new Date().getMonth() + 1)
      }-${(new Date().getDate() < 10 ? "0" : "") + new Date().getDate()}`,
      paymentLink: null,
      loading: false,
      error: null,
      schooldata: null,
      activeTab: "payment", // "payment" or "history"
      paymentHistory: [],
      loadingHistory: false,
      downloadingReceiptNo: null,
    };

    // Create a reusable axios instance without authorization headers
    this.axiosInstance = axios.create();
    delete this.axiosInstance.defaults.headers.common["Authorization"];
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "School Fee Payment Portal";
    this.fetchSchoolInfo();
  }

  fetchSchoolInfo = () => {
    this.axiosInstance
      .get("/api/schoolinfo", {
        params: { api_url: axios.defaults.baseURL },
        type: "json",
        headers: {
          "Content-Type": "application/json",
          Authorization: undefined,
        },
      })
      .then((res) => {
        this.setState({ schooldata: res.data[0] });
        // Store school info for payment gateway selection
        store.set("school_info", res.data[0]);
      })
      .catch((error) => {
        console.error("Error fetching school info:", error);
      });
  };

  handleSearchChange = (e) => {
    this.setState({ admissionNo: e.target.value });
  };

  handleSearch = (e) => {
    e.preventDefault();
    this.setState({
      isSearching: true,
      searchCompleted: false,
      collectfee: [],
      studentData: null,
      selectcollectfee: [],
      total_amount: 0,
      partial_payment_amount: 0,
      isPartialPayment: false,
      error: null,
    });

    this.axiosInstance
      .get("/api/public-collectfee", {
        params: { admission_no: this.state.admissionNo },
        headers: {
          "Content-Type": "application/json",
          Authorization: undefined,
        },
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const studentInfo = res.data[0].student_info;

          this.setState({
            collectfee: res.data,
            studentData: studentInfo,
            student_class: studentInfo.student_class,
            student_section: studentInfo.student_section,
            isSearching: false,
            searchCompleted: true,
          });
        } else {
          this.setState({
            isSearching: false,
            searchCompleted: true,
            error: "No fee details found for this admission number.",
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        this.setState({
          isSearching: false,
          searchCompleted: true,
          error: "Failed to fetch fee details. Please try again.",
        });
      });
  };

  handleCheckbox = (event) => {
    const selectcollectfee = [...this.state.selectcollectfee];
    const feeId = Number(event.target.value);
    const index = selectcollectfee.indexOf(feeId);
    let total_amount = this.state.total_amount;

    if (index !== -1) {
      // If already selected, deselect it
      selectcollectfee.splice(index, 1);

      // Subtract fee amount from total
      for (let k = 0; k < this.state.collectfee.length; k++) {
        if (Number(this.state.collectfee[k].id) === feeId) {
          total_amount =
            Number(total_amount) -
            (this.state.collectfee[k].total_fee -
              this.state.collectfee[k].paid_fee);
        }
      }
    } else {
      // If not selected, select it
      selectcollectfee.push(feeId);

      // Add fee amount to total
      for (let j = 0; j < this.state.collectfee.length; j++) {
        if (Number(this.state.collectfee[j].id) === feeId) {
          total_amount =
            Number(total_amount) +
            (this.state.collectfee[j].total_fee -
              this.state.collectfee[j].paid_fee);
        }
      }
    }

    this.setState({
      selectcollectfee,
      total_amount: Number(total_amount),
      partial_payment_amount: Number(total_amount),
      isPartialPayment: false,
    });
  };

  togglePartialPayment = () => {
    this.setState((prevState) => ({
      isPartialPayment: !prevState.isPartialPayment,
      partial_payment_amount: prevState.total_amount,
    }));
  };

  handlePartialAmountChange = (e) => {
    const amount = Number(e.target.value);
    this.setState({ partial_payment_amount: amount });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    if (this.state.selectcollectfee.length === 0) {
      this.setState({
        loading: false,
        error: "Please select at least one fee to pay.",
      });
      return;
    }

    // Validate partial payment amount
    if (this.state.isPartialPayment) {
      if (this.state.partial_payment_amount <= 0) {
        this.setState({
          loading: false,
          error: "Partial payment amount must be greater than zero.",
        });
        return;
      }

      if (this.state.partial_payment_amount > this.state.total_amount) {
        this.setState({
          loading: false,
          error: "Partial payment cannot exceed the total amount due.",
        });
        return;
      }
    }

    let obj = {};
    obj.orderAmount = this.state.isPartialPayment
      ? this.state.partial_payment_amount
      : this.state.total_amount;
    obj.student_info = this.state.studentData.id;
    obj.fee_collected_details = "";
    obj.collect_fee = this.state.selectcollectfee;
    obj.admission_no = this.state.admissionNo;
    obj.is_partial_payment = this.state.isPartialPayment;

    // Determine payment endpoint
    const paymentEndpoint =
      store.get("school_info").school_online_payment_config__payment_mode ===
      "cashfree"
        ? `/payment/cashfree-online-payment`
        : "/api/hdfc-payment";

    // Use the axiosInstance to avoid auth headers
    this.axiosInstance
      .post(paymentEndpoint, obj, {
        headers: {
          "Content-Type": "application/json",
          //   Authorization: undefined,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.type === "html") {
            var myWindow = window.open("", "response", "resizable=yes");
            myWindow.document.write(response.data.data);
            this.setState({
              loading: false,
            });
          } else {
            this.setState({
              paymentLink: response.data.payment_link,
              loading: false,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Payment API Error:", error);
        this.setState({
          loading: false,
          error: "Failed to generate payment link. Please try again.",
        });
      });
  };

  calculateConvenienceFee = (amount) => {
    return Math.round((amount * 0.022).toFixed(2));
  };

  switchTab = (tab) => {
    this.setState({ activeTab: tab });

    // Fetch payment history when switching to history tab for the first time
    if (tab === "history" && this.state.paymentHistory.length === 0) {
      this.fetchPaymentHistory();
    }
  };

  fetchPaymentHistory = () => {
    this.setState({ loadingHistory: true });

    this.axiosInstance
      .get("/api/public-student-payment-history", {
        params: { admission_no: this.state.admissionNo },
        headers: {
          "Content-Type": "application/json",
          Authorization: undefined,
        },
      })
      .then((res) => {
        this.setState({
          paymentHistory: res.data?.payment_history || [],
          loadingHistory: false,
        });
      })
      .catch((error) => {
        console.error("Payment history fetch error:", error);
        this.setState({
          paymentHistory: [],
          loadingHistory: false,
        });
      });
  };

  handlePrintReceipt = (payment) => {
    console.log("Downloading receipt for:", payment);

    this.setState({ downloadingReceiptNo: payment.receipt_no });

    this.axiosInstance
      .get(`/api/public-fee-receipt-pdf/${payment.id}`, {
        responseType: "blob",
        headers: {
          Authorization: undefined,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `receipt_${payment.receipt_no}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.setState({ downloadingReceiptNo: null });
      })
      .catch((error) => {
        console.error("Error downloading receipt:", error);
        alert("Failed to download receipt. Please try again.");
        this.setState({ downloadingReceiptNo: null });
      });
  };

  render() {
    const {
      admissionNo,
      isSearching,
      searchCompleted,
      collectfee,
      studentData,
      selectcollectfee,
      total_amount,
      partial_payment_amount,
      isPartialPayment,
      paymentLink,
      loading,
      error,
      schooldata,
      activeTab,
      paymentHistory,
      loadingHistory,
      downloadingReceiptNo,
    } = this.state;

    // Calculate the current payment amount based on partial payment toggle
    const currentPaymentAmount = isPartialPayment
      ? partial_payment_amount
      : total_amount;

    // Calculate convenience fee
    const convenienceFee = this.calculateConvenienceFee(currentPaymentAmount);

    // Calculate final total
    const finalTotal = Number(currentPaymentAmount) + convenienceFee;

    return (
      <div>
        <div
          className="th-login-cover"
          style={{
            backgroundImage: `url(${
              schooldata?.dashboard_bg ? schooldata?.dashboard_bg : Cover2
            })`,
          }}
        ></div>

        <div
          style={{
            zIndex: 10,
          }}
          className="container th-login-container th-bg-white"
        >
          <div className="flex-column mx-auto py-2">
            <div className="mx-auto px-auto th-24">
              <div className="rounded">
                <div
                  className="th-login-profile"
                  style={{
                    backgroundImage: `url(${
                      schooldata?.logo ? schooldata?.logo : Cover2
                    })`,
                  }}
                ></div>
              </div>
            </div>
            <span className="th-12 th-medium pl-0">
              <p className="mb-0 text-center th-24 th-fw-700 th-black">
                {schooldata?.school_name || "School Fee Payment Portal"}
              </p>
              <p className="mb-0 th-black text-center th-12 pt-2">
                {schooldata?.school_address || ""}
              </p>
            </span>
          </div>

          <div className="fee-payment-form-container">
            {!searchCompleted ? (
              <form onSubmit={this.handleSearch} className="pt-4">
                <div className="input-group input-group pb-2 flex-column">
                  <span className="th-16 th-grey pb-1">Admission Number</span>
                  <input
                    style={{ fontSize: "16px" }}
                    className="form-control w-100 th-br-8 p-4"
                    name="admissionNo"
                    type="text"
                    value={admissionNo}
                    onChange={this.handleSearchChange}
                    placeholder="Enter your admission number"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn w-100 mt-3"
                  style={{
                    background:
                      "linear-gradient(to right, #314755 0%, #26a0da 51%, #314755 100%)",
                    border: "none",
                    color: "#fff",
                    padding: "10px 20px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  disabled={isSearching || !admissionNo}
                >
                  {isSearching ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <>
                      <i className="fa fa-search mr-2"></i>
                      SEARCH
                    </>
                  )}
                </button>
              </form>
            ) : null}

            {error && <div className="alert alert-danger mt-3">{error}</div>}

            {isSearching && (
              <div className="text-center py-5 mt-4">
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    borderWidth: "0.25em",
                    color: "#26a0da",
                  }}
                />
              </div>
            )}

            {searchCompleted && studentData && (
              <div className="mt-4">
                <div className="student-info-card">
                  <h5 className="th-16 th-bold th-black">Student Details</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <p className="th-14 th-black mb-2">
                        <span className="th-grey">Name:</span>{" "}
                        {studentData?.user?.first_name}{" "}
                        {studentData?.user?.last_name}
                      </p>
                      <p className="th-14 th-black mb-2">
                        <span className="th-grey">Admission No:</span>{" "}
                        {studentData?.student?.admission_no}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p className="th-14 th-black mb-2">
                        <span className="th-grey">Class:</span>{" "}
                        {studentData?.student_class?.class_name}
                      </p>
                      <p className="th-14 th-black mb-2">
                        <span className="th-grey">Section:</span>{" "}
                        {studentData?.section?.section_name}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Tab Navigation */}
                <div className="tab-navigation mt-3 mb-3 d-flex border-bottom">
                  <button
                    type="button"
                    onClick={() => this.switchTab("payment")}
                    className={`tab-btn ${activeTab === "payment" ? "active" : ""}`}
                    style={{
                      background: "none",
                      border: "none",
                      borderBottom:
                        activeTab === "payment"
                          ? "2px solid #26a0da"
                          : "2px solid transparent",
                      color: activeTab === "payment" ? "#26a0da" : "#6c757d",
                      padding: "10px 16px",
                      fontSize: "14px",
                      fontWeight: activeTab === "payment" ? "600" : "400",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      flex: 1,
                    }}
                  >
                    Make Payment
                  </button>
                  <button
                    type="button"
                    onClick={() => this.switchTab("history")}
                    className={`tab-btn ${activeTab === "history" ? "active" : ""}`}
                    style={{
                      background: "none",
                      border: "none",
                      borderBottom:
                        activeTab === "history"
                          ? "2px solid #26a0da"
                          : "2px solid transparent",
                      color: activeTab === "history" ? "#26a0da" : "#6c757d",
                      padding: "10px 16px",
                      fontSize: "14px",
                      fontWeight: activeTab === "history" ? "600" : "400",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      flex: 1,
                    }}
                  >
                    Payment History
                  </button>
                </div>

                {/* Tab Content */}
                {activeTab === "history" ? (
                  <div className="payment-history-section mt-3">
                    {loadingHistory ? (
                      <div className="text-center py-5">
                        <div
                          className="spinner-border"
                          role="status"
                          style={{
                            width: "2.5rem",
                            height: "2.5rem",
                            borderWidth: "0.25em",
                            color: "#26a0da",
                          }}
                        />
                      </div>
                    ) : paymentHistory.length > 0 ? (
                      <div className="payment-history-list">
                        {paymentHistory.map((payment, index) => (
                          <div
                            key={payment.receipt_no || index}
                            className="border mb-2"
                            style={{
                              backgroundColor: "#fff",
                              borderColor: "#e0e0e0",
                              borderRadius: "8px",
                              padding: "10px 12px",
                            }}
                          >
                            {/* Row 1: Receipt No and Amount */}
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <div>
                                <div className="th-11 th-grey">Receipt No</div>
                                <div className="th-14 th-bold th-black">
                                  {payment.receipt_no}
                                </div>
                              </div>
                              <div className="text-right">
                                <div className="th-11 th-grey">Amount</div>
                                <div className="th-15 th-bold th-black th-roboto">
                                  ₹{Number(payment.amount_paid).toFixed(2)}
                                </div>
                              </div>
                            </div>

                            {/* Row 2: Date and Method */}
                            <div
                              className="d-flex justify-content-between align-items-center mb-1 pb-1"
                              style={{ borderBottom: "1px solid #f0f0f0" }}
                            >
                              <div>
                                <div className="th-11 th-grey">Date</div>
                                <div className="th-13 th-black">
                                  {new Date(
                                    payment.payment_date,
                                  ).toLocaleDateString("en-IN", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })}
                                </div>
                              </div>
                              <div className="text-right">
                                <div className="th-11 th-grey">Method</div>
                                <div className="th-13 th-black">
                                  {payment.payment_method_name}
                                </div>
                              </div>
                            </div>

                            {/* Row 3: Transaction No */}
                            <div className="mb-1 pt-1">
                              <div className="th-11 th-grey">
                                Transaction No
                              </div>
                              <div
                                className="th-12 th-black th-roboto"
                                style={{
                                  wordBreak: "break-all",
                                  fontSize: "11px",
                                  lineHeight: "1.3",
                                }}
                              >
                                {payment.transaction_no}
                              </div>
                            </div>

                            {/* Row 4: Download Button */}
                            <button
                              type="button"
                              onClick={() => this.handlePrintReceipt(payment)}
                              className="btn w-100 mt-1"
                              disabled={
                                downloadingReceiptNo === payment.receipt_no
                              }
                              style={{
                                background: "#26a0da",
                                color: "#fff",
                                border: "none",
                                padding: "5px 10px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                fontWeight: "500",
                                opacity:
                                  downloadingReceiptNo === payment.receipt_no
                                    ? 0.7
                                    : 1,
                              }}
                            >
                              {downloadingReceiptNo === payment.receipt_no ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                <>
                                  <i className="fa fa-download mr-1"></i>
                                  Download
                                </>
                              )}
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div
                        className="text-center py-5"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "8px",
                        }}
                      >
                        <i
                          className="fa fa-receipt th-grey"
                          style={{ fontSize: "48px", opacity: 0.3 }}
                        ></i>
                        <p className="th-14 th-grey mt-3 mb-0">
                          No payment history found
                        </p>
                      </div>
                    )}
                  </div>
                ) : null}

                {activeTab === "payment" &&
                  (paymentLink ? (
                    <div className="payment-summary-card mt-4">
                      <h5 className="th-16 th-bold th-black mb-3">
                        Payment Summary
                      </h5>
                      <div className="th-14 th-black mb-2 d-flex justify-content-between">
                        <span>Sub Total:</span>
                        <span className="th-roboto">
                          ₹ {currentPaymentAmount.toFixed(2)}
                        </span>
                      </div>
                      <div className="th-14 th-black mb-2 d-flex justify-content-between">
                        <span>
                          Convenience fee <span className="th-12">(2.2%)</span>:
                        </span>
                        <span className="th-roboto">₹ {convenienceFee}</span>
                      </div>
                      <div className="th-14 th-bold th-black mb-4 d-flex justify-content-between">
                        <span>Total:</span>
                        <span className="th-roboto">
                          ₹ {finalTotal.toFixed(2)}
                        </span>
                      </div>
                      <a
                        href={paymentLink}
                        className="btn w-100 text-center"
                        style={{
                          background:
                            "linear-gradient(to right, #314755 0%, #26a0da 51%, #314755 100%)",
                          border: "none",
                          color: "#fff",
                          padding: "10px 20px",
                          borderRadius: "6px",
                          fontSize: "14px",
                          fontWeight: "500",
                          textDecoration: "none",
                          display: "block",
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PAY NOW
                      </a>
                    </div>
                  ) : (
                    <div className="mt-3">
                      <h5 className="th-15 th-bold th-black mb-3">
                        Select Fees to Pay
                      </h5>
                      <div className="fee-items-container">
                        {collectfee.length > 0 ? (
                          collectfee.map(
                            (item, index) =>
                              item.paid_status !== true && (
                                <div key={index} className="fee-item-card mb-2">
                                  <div className="form-check d-flex align-items-center p-0">
                                    <input
                                      type="checkbox"
                                      className="form-check-input ml-0 me-3"
                                      id={`fee-${item.id}`}
                                      value={item.id}
                                      onChange={this.handleCheckbox}
                                      disabled={
                                        item?.paid_fee === item.total_fee
                                      }
                                      checked={selectcollectfee.includes(
                                        item.id,
                                      )}
                                    />
                                    <label
                                      className="form-check-label flex-grow-1 mb-0 pl-5"
                                      htmlFor={`fee-${item.id}`}
                                    >
                                      <div className="th-14 th-medium th-black">
                                        {item.fee_group
                                          ? item.fee_group.term_fee.term_name
                                          : "Back Due Of Last Session"}
                                        {(item.total_fee - item.paid_fee ===
                                          0 ||
                                          item?.paid_status === true) && (
                                          <span className="fee-status-badge">
                                            Paid
                                          </span>
                                        )}
                                      </div>
                                      <div className="mt-1 th-roboto th-14">
                                        Amount Due: ₹{" "}
                                        {(
                                          item.total_fee - item.paid_fee
                                        ).toFixed(2)}
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              ),
                          )
                        ) : (
                          <div className="alert-info-card">
                            No pending fees found.
                          </div>
                        )}
                      </div>

                      {collectfee.length > 0 && selectcollectfee.length > 0 && (
                        <div className="payment-total-card mt-4">
                          <div className="th-14 th-bold th-black mb-3 d-flex justify-content-between">
                            <span>Total Amount Due:</span>
                            <span className="th-roboto">
                              ₹ {total_amount.toFixed(2)}
                            </span>
                          </div>

                          {/* Partial Payment Toggle */}
                          <div className="form-check mb-3">
                            <input
                              type="checkbox"
                              className="form-check-input mt-1"
                              id="partialPayment"
                              checked={isPartialPayment}
                              onChange={this.togglePartialPayment}
                            />
                            <label
                              className="form-check-label th-14 th-medium"
                              htmlFor="partialPayment"
                            >
                              Pay a custom amount
                            </label>
                          </div>

                          {/* Partial Payment Amount Input */}
                          {isPartialPayment && (
                            <div className="mb-3">
                              <label
                                htmlFor="partialAmount"
                                className="th-14 th-medium mb-2"
                              >
                                Enter amount to pay:
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">₹</span>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="partialAmount"
                                  placeholder="Enter amount"
                                  min="1"
                                  max={total_amount}
                                  value={partial_payment_amount}
                                  onChange={this.handlePartialAmountChange}
                                />
                              </div>
                              <small className="th-12 th-grey">
                                Amount should be between ₹1 and ₹
                                {total_amount.toFixed(2)}
                              </small>
                            </div>
                          )}

                          {/* Payment Summary */}
                          <div className="payment-summary-section p-3 mt-3 mb-3 border rounded">
                            <h6 className="th-14 th-bold mb-2">
                              Payment Summary
                            </h6>
                            <div className="th-14 th-black mb-2 d-flex justify-content-between">
                              <span>Amount:</span>
                              <span className="th-roboto">
                                ₹ {currentPaymentAmount.toFixed(2)}
                              </span>
                            </div>
                            <div className="th-14 th-black mb-2 d-flex justify-content-between">
                              <span>
                                Convenience fee{" "}
                                <span className="th-12">(2.2%)</span>:
                              </span>
                              <span className="th-roboto">
                                ₹ {convenienceFee}
                              </span>
                            </div>
                            <div className="th-14 th-bold th-black d-flex justify-content-between">
                              <span>Total:</span>
                              <span className="th-roboto">
                                ₹ {finalTotal.toFixed(2)}
                              </span>
                            </div>
                          </div>

                          <button
                            type="button"
                            onClick={this.handleSubmit}
                            className="btn w-100"
                            style={{
                              background:
                                "linear-gradient(to right, #314755 0%, #26a0da 51%, #314755 100%)",
                              border: "none",
                              color: "#fff",
                              padding: "10px 20px",
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                            disabled={
                              loading ||
                              selectcollectfee.length === 0 ||
                              (isPartialPayment &&
                                partial_payment_amount <= 0) ||
                              (isPartialPayment &&
                                partial_payment_amount > total_amount)
                            }
                          >
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "PROCEED TO PAYMENT"
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            )}

            <div className="d-flex justify-content-center th-black mt-5 pb-4">
              <a href="https://gungunerp.com/">
                <div className="th-14 th-bold">
                  Powered By :{" "}
                  <span className="th-primary">
                    Gungun Erp Solution Pvt. Ltd.
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PublicFeePayment;
